import React from "react"
import { Icon } from "@mostlycode/ui"
import { getIconFromUrl } from "utils/iconResolver"
import styled from "styled-components"
import Section from "../Section"
import Content from "../Content"
import CustomList from "components/CustomList"
import { isEmpty, valuable } from "utils/worthy"

const StyledSection = styled(Section)`
  h2 {
    text-transform: uppercase;
    // margin-bottom: 0;
  }

  p {
    font-size: 1.8rem;
    line-height: 1.5;
  }
`

function ContentBlock({ data, list }) {
  const { heading, content, is_primary } = data
  const [firstItem] = list
  if (isEmpty(firstItem)) list = null
  const html = <Content content={heading} />
  const list_section = valuable(list) ? (
    <CustomList>
      {list.map((item) => {
        const { icon_image, item_text } = item
        return (
          <li>
            <Icon icon={getIconFromUrl(icon_image?.url)} />
            {item_text}
          </li>
        )
      })}
    </CustomList>
  ) : null
  return (
    <StyledSection
      bg={is_primary ? "plush" : "white"}
      color="primary"
      left={html}
    >
      <article>
        <Content content={content} />
        {list_section}
      </article>
    </StyledSection>
  )
}

export default ContentBlock
